// Phase 6 — Track E T-E3. ListRow primitive (hand-rolled).
//
// A horizontally-arranged row used for transaction / event / alert lists.
// Default padding follows blueprint §14.3 (componentPadding.listRow:
// 12px y × 16px x). Hover surface lifts to surface-raised; focus-visible
// emits the ring.

import * as React from 'react';
import { cn } from '../../lib/cn.js';

export interface ListRowProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Optional render-as for keyboard-actionable rows (button or link). */
  asChild?: boolean;
  interactive?: boolean;
}

export const ListRow = React.forwardRef<HTMLDivElement, ListRowProps>(
  ({ className, interactive = false, role, ...props }, ref) => (
    <div
      ref={ref}
      role={role ?? (interactive ? 'button' : undefined)}
      tabIndex={interactive ? 0 : undefined}
      className={cn(
        'flex items-center gap-3 px-4 py-3 border-b border-border-subtle last:border-b-0 text-body text-text-primary',
        interactive &&
          'cursor-pointer hover:bg-accent-subtle focus-visible:outline-none focus-visible:bg-accent-subtle',
        className,
      )}
      {...props}
    />
  ),
);
ListRow.displayName = 'ListRow';
